import Button from "@/shared/form/button";
import { CloseOutlined, MessageOutlined } from "@ant-design/icons";
import { UserFeedbackForm } from "./user-feedback-form";
import { useTranslations } from "use-intl";
import Card from "@/shared/data-display/card";
import { useState } from "react";
import { createPortal } from "react-dom";

export function UserFeedback() {
  const t = useTranslations("Feedback");

  const [isOpen, setIsOpen] = useState(false);
  const close = () => setIsOpen(false);

  return (
    <>
      <Button
        type="default"
        shape="circle"
        icon={<MessageOutlined />}
        onClick={() => setIsOpen(true)}
      />

      {isOpen &&
        createPortal(
          <Card
            className="!fixed bottom-3 right-3 w-[300px] z-50"
            classNames={{
              body: "max-h-[70vh] overflow-auto",
            }}
            title={t("Feedback")}
            extra={
              <Button type="text" onClick={close} icon={<CloseOutlined />} />
            }
          >
            <UserFeedbackForm afterSubmit={close} />
          </Card>,
          document.body,
        )}
    </>
  );
}
